import React from 'react';

const ErrorPage = () => {
    return (
        <div>
            <h2>The page you are looking for not found</h2>
            <img src='https://img.freepik.com/free-vector/404-error-with-person-looking-concept-illustration_114360-7912.jpg?size=626&ext=jpg&ga=GA1.2.1429049582.1665419688&semt=sph'></img>
        </div>
    );
};

export default ErrorPage;